import { toast } from "react-toastify";
import {
  EXPORT_ACCOUNTING_CSV,
  EXPORT_AGENCIES_CSV,
  EXPORT_CUSTOMER_CSV,
  EXPORT_DRIVERS_CSV,
  EXPORT_DRIVERREPORT_CSV,
} from "../services/ApiCalls";

export function createObjectURL(object) {
  return window.URL
    ? window.URL.createObjectURL(object)
    : window.webkitURL.createObjectURL(object);
}

export const exportCsvHandler = async (data) => {
  try {
    let res;
    if (data === "customers") {
      res = await EXPORT_CUSTOMER_CSV();
    }
    if (data === "agencies") {
      res = await EXPORT_AGENCIES_CSV();
    }
    if (data === "drivers") {
      res = await EXPORT_DRIVERS_CSV();
    }
    if (data === "accounting") {
      res = await EXPORT_ACCOUNTING_CSV();
    }
    if (data === "driverreport") {
      res = await EXPORT_DRIVERREPORT_CSV();
    }

    console.log(res);
    if (res.status === 200) {
      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(res.data);
      hiddenElement.target = "_blank";
      hiddenElement.download = `${data} Report.csv`;
      hiddenElement.click();
    } else {
      toast.error("something went wrong");
    }
  } catch (error) {
    toast.error("something went wrong");
  }
};

export function getLast7Days() {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dates = [];
  for (let i = 1; i <= 7; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const day = date.getDate();
    const month = months[date.getMonth()];
    dates.push(`${day} ${month}`);
  }

  return dates.reverse();
}

export const catchAsync = (fn) => {
  return (...arg) =>
    fn(...arg).catch((error) => {
      toast.error("something went wrong");
      console.log(error, "error");
    });
};

export const checkResponse = ({
  res,
  setData,
  setTotal,
  showSuccess,
  dataToSet,
}) => {
  if (res?.data?.status === "success") {
    setData && setData(dataToSet || res?.data?.data);
    setTotal && setTotal(res?.data?.totalcount);
    showSuccess && toast.success(res?.data?.message);
    return true;
  } else {
    toast.error(res?.data?.message);
  }
};
